import React, { useCallback, useState } from 'react';
import { TextInput, Icon } from '@tcc/crate';
import styles from '../scoutingForm.css';

type ScoutingFormTitleProps = {
  title: string;
  setTitle: (title: string) => void;
  isEditingTitle: boolean
  setIsEditingTitle: React.Dispatch<React.SetStateAction<boolean>>
}

export const ScoutingFormTitle = ({
  title, setTitle, isEditingTitle, setIsEditingTitle
}: ScoutingFormTitleProps) => {
  const [displayTitle] = useState(title);

  const onClose = useCallback(() => {
    setTitle(displayTitle);
    setIsEditingTitle(false);
  }, [displayTitle, setTitle, setIsEditingTitle]);

  const onSave = useCallback(() => {
    setIsEditingTitle(false);
  }, [setIsEditingTitle]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  return (
    <div className={styles.enhancedScoutingEditingTitleContainer}>
      {isEditingTitle ?
        <>
          <TextInput
            showReset={false}
            showLabel={false}
            maxLength="40"
            isRequired
            value={title}
            onChange={onChange}
            className={styles.enhancedScoutingEditingTitleInput}
            labelClassName={styles.enhancedScoutingEditingTitleLabel}
           />
          <Icon
            glyph={Icon.set.CANCEL}
            className={`${styles.enhancedScoutingIcon} ${styles.enhancedScoutingIconIsEditing} ${styles.cursorPointer}`}
            onClick={onClose}
            testId="enhanced-scouting-cancel-edit-title-icon"
          />
          <Icon
            glyph={Icon.set.MATERIAL_CHECK}
            className={`${styles.enhancedScoutingIcon} ${styles.enhancedScoutingIconIsEditing} ${styles.cursorPointer}`}
            onClick={onSave}
            testId="enhanced-scouting-confirm-edit-title-icon"
          />
        </>
      : <>
        <div data-test-id="enhanced-scouting-edit-title-value">{title}</div>
        <Icon
          onClick={() => { setIsEditingTitle(true) }}
          glyph={Icon.set.PENCIL}
          className={`${styles.enhancedScoutingIcon} ${styles.enhancedScoutingEditingTitleEditIcon} ${styles.cursorPointer}`}
          testId="enhanced-scouting-edit-title-icon" />
      </>}
    </div>
  )
}
